export default "__VITE_ASSET__zufRYamL5CBgY905DU5FCg__"